import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftIdentity = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_identity)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M1.724 11.6093C1.47393 11.8593 1.33341 12.1984 1.33333 12.552V14C1.33333 14.1768 1.40357 14.3464 1.5286 14.4714C1.65362 14.5964 1.82319 14.6667 2 14.6667H4C4.17681 14.6667 4.34638 14.5964 4.4714 14.4714C4.59643 14.3464 4.66667 14.1768 4.66667 14V13.3333C4.66667 13.1565 4.7369 12.987 4.86193 12.8619C4.98695 12.7369 5.15652 12.6667 5.33333 12.6667H6C6.17681 12.6667 6.34638 12.5964 6.4714 12.4714C6.59643 12.3464 6.66667 12.1768 6.66667 12V11.3333C6.66667 11.1565 6.7369 10.987 6.86193 10.8619C6.98695 10.7369 7.15652 10.6667 7.33333 10.6667H7.448C7.80159 10.6666 8.14068 10.5261 8.39067 10.276L8.93333 9.73333C9.85989 10.0561 10.8686 10.0549 11.7943 9.72983C12.7201 9.40481 13.5081 8.77522 14.0296 7.94408C14.551 7.11294 14.7749 6.12945 14.6647 5.15449C14.5545 4.17953 14.1167 3.27083 13.423 2.57705C12.7292 1.88326 11.8205 1.44546 10.8455 1.33526C9.87055 1.22506 8.88706 1.449 8.05592 1.97043C7.22478 2.49186 6.59519 3.27991 6.27017 4.20568C5.94514 5.13144 5.9439 6.14011 6.26667 7.06667L1.724 11.6093Z",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M11 5.33333C11.1841 5.33333 11.3333 5.18409 11.3333 5C11.3333 4.8159 11.1841 4.66667 11 4.66667C10.8159 4.66667 10.6667 4.8159 10.6667 5C10.6667 5.18409 10.8159 5.33333 11 5.33333Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_identity",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgMicrosoftIdentity;
